import { render, staticRenderFns } from "./PalettePicker.vue?vue&type=template&id=132b2951&scoped=true&"
import script from "./PalettePicker.vue?vue&type=script&lang=js&"
export * from "./PalettePicker.vue?vue&type=script&lang=js&"
import style0 from "./PalettePicker.vue?vue&type=style&index=0&id=132b2951&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b2951",
  null
  
)

export default component.exports